import { css } from 'lit';

var css_248z = css`:host{--accordion-active-color:var(--sgds-primary)}`;

export { css_248z as default };
//# sourceMappingURL=sgds-accordion2.js.map
